import { Title } from "react-admin";
import { useSearchParams } from "react-router-dom";
import { HouseVisitSlotList } from "./HouseVisitSlotList";
import { HouseVisitSlotsCalendarView } from "./HouseVisitSlotsCalendarView";

export const HouseVisitSlotListRouter = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "CALENDAR";

  return (
    <>
      <Title title="Slots" />
      {tab === "LIST" ? <HouseVisitSlotList /> : <HouseVisitSlotsCalendarView />}
    </>
  );
};

export default HouseVisitSlotListRouter;
